/* eslint-disable */
import React, { useCallback, useState, useEffect } from 'react'
import { Layout, Menu, Icon, Breadcrumb } from 'antd'
import { Route, Redirect, Switch, useRouteMatch, useHistory } from "react-router-dom"
import List from './list'
import RequestList from './request'
import WorkerDialog from '@/components/dialogs/WorkerDialog'
import styles from './workers.module.scss'

const { Sider } = Layout;

function Worker() {
  const match = useRouteMatch();
  const history = useHistory()
  // const { path } = match

  // console.log('path:', path)

  let selectedKeys
  try {
    selectedKeys = window.location.pathname.slice(1).split('/')[1]
  } catch (e) { }

  const onClick = useCallback(({ key }) => {
    history.push(`/workers/${key}`)
  })

  // console.log('selectedKeys:', window.location.pathname.split('/'))

  return (
    <Layout>
      {/* <Sider width={160} style={{ background: '#fff' }}>
        <Menu
          mode="inline"
          selectedKeys={[selectedKeys]}
          onClick={onClick}
          style={{ height: '100%', borderRight: 0 }}>
          <Menu.Item key="list">
            <Icon type="ordered-list" />
            <span>已入驻</span>
          </Menu.Item>
          <Menu.Item key="request">
            <Icon type="pull-request" />
            <span>入驻申请</span>
          </Menu.Item>
        </Menu>
      </Sider> */}
      <Layout>
        <div className={styles.container}>
          <div className={styles.header}>
            <Breadcrumb>
              <Breadcrumb.Item>师傅管理</Breadcrumb.Item>
              {
                selectedKeys === 'list' && (
                  <Breadcrumb.Item>已入驻</Breadcrumb.Item>
                )
              }
              {
                selectedKeys === 'request' && (
                  <Breadcrumb.Item>入驻申请</Breadcrumb.Item>
                )
              }
            </Breadcrumb>
          </div>
          <Switch>
            <Redirect from="/workers" exact strict to="/workers/list" />
            <Route path="/workers/list" strict exact component={List} />
            <Route path="/workers/request" strict exact component={RequestList} />
          </Switch>
        </div>
        <WorkerDialog />
      </Layout>
    </Layout>
  )
}

export default Worker
